import React from 'react'
import styled from 'styled-components'

import Brand from 'helpers/brand'
import LibraryDetails from './LibraryDetails'

import { PageTitle } from 'styles/shared'
import { color } from 'styles/colors'

const Legal = () => {
  const businessUnitName = Brand.isCommercial() ? 'Trane Commercial HVAC' : 'Trane Residential HVAC'
  return (
    <S.Legal>
      <PageTitle>Legal</PageTitle>

      <p>The software included in this product contains copyrighted software that is licensed under the GPL,
        LGPL or other copyleft license. A copy of those licenses is included herewith. You may obtain the complete corresponding source code from us for a period of three years after our last shipment of this product by sending a request letter to:
      </p>
      <p>{businessUnitName}
        <br />
        <span>Attn: Open Source Compliance</span>
        <br />
        <span>800-E Beaty St.</span>
        <br />
        <span>PO Box 940</span>
        <br />
        <span>Davidson, NC 28036</span>
      </p>
      <p>*Please include the name of the product and, if applicable, the version number of the software in the request letter.
        <br />
        <span>**This offer is valid to anyone in receipt of this information.</span>
      </p>
      <LibraryDetails />
    </S.Legal>
  )
}
export default Legal

const S = {
  Legal: styled.div`
  padding:15px;
  border-radius: 5px;
  border-top: 15px solid ${color('titleText')};
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
  & > h5 {
    color: ${color('headerText')};
    font-weight: 900;
  }
  `
}
